var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignVehicleInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M18.92 6.01C18.72 5.42 18.14 5 17.5 5h-11c-.64 0-1.22.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 7h11l1.16 3.5H5.34L6.5 7zM19 17H5v-5h14v5zM7.5 14.5c.83 0 1.5.67 1.5 1.5S8.33 17.5 7.5 17.5 6 16.83 6 16s.67-1.5 1.5-1.5zm9 0c.83 0 1.5.67 1.5 1.5S17.33 17.5 16.5 17.5 15 16.83 15 16s.67-1.5 1.5-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignVehicleInactive);
export default __webpack_public_path__ + "static/media/assignVehicleInactive.8f3dd4ae91f576cc3295a6417ca915d2.svg";
export { ForwardRef as ReactComponent };